import { render, staticRenderFns } from "./CoAudioEmbed.vue?vue&type=template&id=94f38296&scoped=true&"
import script from "./CoAudioEmbed.vue?vue&type=script&lang=ts&"
export * from "./CoAudioEmbed.vue?vue&type=script&lang=ts&"
import style0 from "./CoAudioEmbed.vue?vue&type=style&index=0&id=94f38296&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94f38296",
  null
  
)

export default component.exports